{
  "change-awareness.seasonal-release-notification-spotlight.action": [
    {
      "type": 0,
      "value": "About Releases"
    }
  ],
  "change-awareness.seasonal-release-notification-spotlight.description": [
    {
      "type": 0,
      "value": "We're soon shipping new features 3 times per year: Spring, Summer, and Autumn."
    }
  ],
  "change-awareness.seasonal-release-notification-spotlight.image-alt": [
    {
      "type": 0,
      "value": "Illustration of seasonal releases"
    }
  ],
  "change-awareness.seasonal-release-notification-spotlight.timing-indicator": [
    {
      "type": 0,
      "value": "Coming soon"
    }
  ],
  "change-awareness.seasonal-release-notification-spotlight.title": [
    {
      "type": 0,
      "value": "Jira is moving to seasonal releases"
    }
  ],
  "release-track.release-track-bundle-bundled-track-app-agnostic.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "release-track.release-track-bundle-bundled-track-app-agnostic.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "release-track.release-track-bundle-bundled-track-app-agnostic.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "release-track.release-track-bundle-bundled-track-app-agnostic.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "release-track.release-track-bundle-bundled-track-app-agnostic.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "release-track.release-track-bundle-bundled-track-app-agnostic.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "release-track.release-track-bundle-bundled-track-app-agnostic.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "release-track.release-track-bundle-bundled-track-no-changes.message-template.email.no-changes": [
    {
      "children": [
        {
          "type": 0,
          "value": "No changes"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "release-track.release-track-bundle-bundled-track-redacted.message-template.email.body": [
    {
      "type": 0,
      "value": "The next bundled release for your products will roll out on "
    },
    {
      "type": 1,
      "value": "releaseDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "release-track.release-track-bundle-bundled-track-redacted.message-template.email.body-appify": [
    {
      "type": 0,
      "value": "The next bundled release for your apps will roll out on "
    },
    {
      "type": 1,
      "value": "releaseDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "release-track.release-track-bundle-bundled-track.message-template.email.body": [
    {
      "type": 0,
      "value": "The next bundled release for your products at "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "siteName"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " will roll out on "
    },
    {
      "type": 1,
      "value": "releaseDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "release-track.release-track-bundle-bundled-track.message-template.email.body-appify": [
    {
      "type": 0,
      "value": "The next bundled release for your apps at "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "siteName"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " will roll out on "
    },
    {
      "type": 1,
      "value": "releaseDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "release-track.release-track-bundle-bundled-track.message-template.email.discovery-content": [
    {
      "type": 0,
      "value": "The first set of features will roll out in June, 2026. Changes will be available to test in sandboxes on the preview track from May, 2026. "
    },
    {
      "type": 1,
      "value": "viewAppUpdatesLink"
    },
    {
      "type": 0,
      "value": " to learn more about upcoming dates and changes."
    }
  ],
  "release-track.release-track-bundle-bundled-track.message-template.email.discovery-title": [
    {
      "type": 0,
      "value": "Jira seasonal releases are coming soon"
    }
  ],
  "release-track.release-track-bundle-bundled-track.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Bundled changes for your product "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "release-track.release-track-bundle-bundled-track.message-template.email.subject.no-translate-appify": [
    {
      "type": 0,
      "value": "Bundled changes for your app "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "release-track.release-track-bundle-bundled-track.message-template.email.title": [
    {
      "type": 0,
      "value": "View the bundled track changes for your "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "wordAfterProduct"
    }
  ],
  "release-track.release-track-bundle-bundled-track.message-template.email.view-product-updates": [
    {
      "type": 0,
      "value": "View bundled changes in Product updates"
    }
  ],
  "release-track.release-track-bundle-bundled-track.message-template.email.view-product-updates-appify": [
    {
      "type": 0,
      "value": "View bundled changes in App updates"
    }
  ],
  "release-track.release-track-bundle-preview-bundle-app-agnostic.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "release-track.release-track-bundle-preview-bundle-app-agnostic.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "release-track.release-track-bundle-preview-bundle-app-agnostic.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "release-track.release-track-bundle-preview-bundle-app-agnostic.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "release-track.release-track-bundle-preview-bundle-app-agnostic.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "release-track.release-track-bundle-preview-bundle-app-agnostic.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "release-track.release-track-bundle-preview-bundle-app-agnostic.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "release-track.release-track-bundle-preview-bundle-redacted.message-template.email.body": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " sandbox has received the below product changes."
    }
  ],
  "release-track.release-track-bundle-preview-bundle-redacted.message-template.email.body-appify": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " sandbox has received the below app changes."
    }
  ],
  "release-track.release-track-bundle-preview-bundle.message-template.email.body": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " sandbox at "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "siteName"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " has received the below product changes."
    }
  ],
  "release-track.release-track-bundle-preview-bundle.message-template.email.body-appify": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " sandbox at "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "siteName"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " has received the below app changes."
    }
  ],
  "release-track.release-track-bundle-preview-bundle.message-template.email.list-item": [
    {
      "children": [
        {
          "type": 1,
          "value": "featureName"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "release-track.release-track-bundle-preview-bundle.message-template.email.no-changes": [
    {
      "type": 0,
      "value": "No changes"
    }
  ],
  "release-track.release-track-bundle-preview-bundle.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Your preview release product changes for "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "release-track.release-track-bundle-preview-bundle.message-template.email.subject.no-translate-appify": [
    {
      "type": 0,
      "value": "Your preview release app changes for "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "release-track.release-track-bundle-preview-bundle.message-template.email.title": [
    {
      "type": 0,
      "value": "Your preview release product changes"
    }
  ],
  "release-track.release-track-bundle-preview-bundle.message-template.email.title-appify": [
    {
      "type": 0,
      "value": "Your preview release app changes"
    }
  ],
  "release-track.release-track-bundle-preview-bundle.message-template.email.view-product-updates": [
    {
      "type": 0,
      "value": "View changes in Product updates"
    }
  ],
  "release-track.release-track-bundle-preview-bundle.message-template.email.view-product-updates-appify": [
    {
      "type": 0,
      "value": "View changes in App updates"
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.body.change-title": [
    {
      "type": 1,
      "value": "changeTitle"
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.body.current-window": [
    {
      "type": 1,
      "value": "currentWindow"
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.body.notice": [
    {
      "type": 0,
      "value": "There's been an update on a release note that you're watching in "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Product updates"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " in your organization administration at "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "adminhubHost"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.body.notice.redacted": [
    {
      "type": 0,
      "value": "There's been an update on a release note that you're watching in "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Product updates"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " in your organization administration."
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.body.previous-window": [
    {
      "type": 1,
      "value": "previousWindow"
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.body.product-affected": [
    {
      "type": 1,
      "value": "productName"
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.body.products-impacted": [
    {
      "type": 0,
      "value": "Products impacted"
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.body.rollout-schedule": [
    {
      "type": 0,
      "value": "Rollout schedule"
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.body.status-title": [
    {
      "type": 0,
      "value": "Status"
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.body.status.change-arrow": [
    {
      "type": 0,
      "value": "→"
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.body.status.coming-soon": [
    {
      "type": 0,
      "value": "Coming soon"
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.body.status.generally-available": [
    {
      "type": 0,
      "value": "Generally available"
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.body.status.planned": [
    {
      "type": 0,
      "value": "Planned"
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.body.status.rolling-out": [
    {
      "type": 0,
      "value": "Rolling out"
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.body.type": [
    {
      "type": 1,
      "value": "changeType"
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.body.type-title": [
    {
      "type": 0,
      "value": "Type"
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.footer.hyphen": [
    {
      "type": 0,
      "value": "-"
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.footer.manage-notifications": [
    {
      "type": 0,
      "value": "Manage notifications for this release note"
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.footer.privacy-policy": [
    {
      "type": 0,
      "value": "Privacy policy"
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.footer.sent-by": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Cloud"
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.footer.view-release-note": [
    {
      "type": 0,
      "value": "View release note"
    }
  ],
  "release-track.release-track-changelog-changelog-update.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "We've updated a release note you're watching "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "release-track.release-track-delay-delay-change.message-template.email.defer-timeline": [
    {
      "type": 0,
      "value": "After a change is announced in "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Product updates,"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " you'll have 10 days to defer the rollout."
    }
  ],
  "release-track.release-track-delay-delay-change.message-template.email.defer-timeline-appify": [
    {
      "type": 0,
      "value": "After a change is announced in "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "App updates,"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " you'll have 10 days to defer the rollout."
    }
  ],
  "release-track.release-track-delay-delay-change.message-template.email.header": [
    {
      "type": 0,
      "value": "Defer the rollout of certain changes"
    }
  ],
  "release-track.release-track-delay-delay-change.message-template.email.learn-more": [
    {
      "type": 0,
      "value": "Understand how to defer a change"
    }
  ],
  "release-track.release-track-delay-delay-change.message-template.email.list1a": [
    {
      "type": 0,
      "value": "You can now defer the rollout of certain changes for products on the continuous track with Enterprise plans."
    }
  ],
  "release-track.release-track-delay-delay-change.message-template.email.list1a-appify": [
    {
      "type": 0,
      "value": "You can now defer the rollout of certain changes for apps on the continuous track with Enterprise plans."
    }
  ],
  "release-track.release-track-delay-delay-change.message-template.email.list1b": [
    {
      "type": 0,
      "value": "To find out which changes can have their rollouts deferred:"
    }
  ],
  "release-track.release-track-delay-delay-change.message-template.email.list2": [
    {
      "type": 0,
      "value": "Go to "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "adminhubBaseUrl"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": ". Select your organization if you have more than one."
    }
  ],
  "release-track.release-track-delay-delay-change.message-template.email.list3": [
    {
      "type": 0,
      "value": "Select "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Products"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " > "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Product updates."
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "release-track.release-track-delay-delay-change.message-template.email.list3-appify": [
    {
      "type": 0,
      "value": "Select "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Apps"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " > "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "App updates."
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "release-track.release-track-delay-delay-change.message-template.email.list4": [
    {
      "type": 0,
      "value": "Go to the "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Defer rollout"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " filter"
    }
  ],
  "release-track.release-track-delay-delay-change.message-template.email.list5": [
    {
      "type": 0,
      "value": "Select "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Can defer."
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "release-track.release-track-delay-delay-change.message-template.email.privacy-policy": [
    {
      "type": 0,
      "value": "Privacy policy"
    }
  ],
  "release-track.release-track-delay-delay-change.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Defer the rollout of changes to your products "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "release-track.release-track-delay-delay-change.message-template.email.subject.no-translate-appify": [
    {
      "type": 0,
      "value": "Defer the rollout of changes to your apps "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "release-track.release-track-delay-delay-change.message-template.email.view-product-updates": [
    {
      "type": 0,
      "value": "Go to Product updates"
    }
  ],
  "release-track.release-track-delay-delay-change.message-template.email.view-product-updates-appify": [
    {
      "type": 0,
      "value": "Go to App updates"
    }
  ],
  "release-track.release-track-delay-delay-opt-in.message-template.email.body.change-type": [
    {
      "type": 1,
      "value": "changeType"
    }
  ],
  "release-track.release-track-delay-delay-opt-in.message-template.email.body.change-type.announcement": [
    {
      "type": 0,
      "value": "Announcement"
    }
  ],
  "release-track.release-track-delay-delay-opt-in.message-template.email.body.change-type.experiment": [
    {
      "type": 0,
      "value": "Experiment"
    }
  ],
  "release-track.release-track-delay-delay-opt-in.message-template.email.body.change-type.fix": [
    {
      "type": 0,
      "value": "Fix"
    }
  ],
  "release-track.release-track-delay-delay-opt-in.message-template.email.body.change-type.improvement": [
    {
      "type": 0,
      "value": "Improvement"
    }
  ],
  "release-track.release-track-delay-delay-opt-in.message-template.email.body.change-type.removed": [
    {
      "type": 0,
      "value": "Removed"
    }
  ],
  "release-track.release-track-delay-delay-opt-in.message-template.email.body.release-note.change-type": [
    {
      "type": 0,
      "value": "Change Type"
    }
  ],
  "release-track.release-track-delay-delay-opt-in.message-template.email.body.release-note.defer": [
    {
      "type": 0,
      "value": "An admin from your organization deferred a change through "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Product updates"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " in "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "adminhubBaseUrl"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "release-track.release-track-delay-delay-opt-in.message-template.email.body.release-note.rollout-schedule": [
    {
      "type": 0,
      "value": "Rollout Schedule"
    }
  ],
  "release-track.release-track-delay-delay-opt-in.message-template.email.body.release-note.status": [
    {
      "type": 0,
      "value": "Status"
    }
  ],
  "release-track.release-track-delay-delay-opt-in.message-template.email.body.release-note.title": [
    {
      "type": 1,
      "value": "title"
    }
  ],
  "release-track.release-track-delay-delay-opt-in.message-template.email.body.rollout-schedule.delayability-deadline": [
    {
      "type": 1,
      "value": "delayabilityDeadline"
    },
    {
      "type": 0,
      "value": " &rarr; Deferred to "
    },
    {
      "type": 1,
      "value": "delayedReleaseDate"
    }
  ],
  "release-track.release-track-delay-delay-opt-in.message-template.email.body.status": [
    {
      "type": 1,
      "value": "status"
    }
  ],
  "release-track.release-track-delay-delay-opt-in.message-template.email.body.status.coming-soon": [
    {
      "type": 0,
      "value": "COMING SOON"
    }
  ],
  "release-track.release-track-delay-delay-opt-in.message-template.email.body.status.generally-available": [
    {
      "type": 0,
      "value": "ROLLOUT COMPLETE"
    }
  ],
  "release-track.release-track-delay-delay-opt-in.message-template.email.body.status.planned": [
    {
      "type": 0,
      "value": "PLANNED"
    }
  ],
  "release-track.release-track-delay-delay-opt-in.message-template.email.body.status.rolling-out": [
    {
      "type": 0,
      "value": "ROLLING OUT"
    }
  ],
  "release-track.release-track-delay-delay-opt-in.message-template.email.body.status.undefined": [
    {
      "type": 0,
      "value": "UNDEFINED"
    }
  ],
  "release-track.release-track-delay-delay-opt-in.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "The rollout of a change is deferred "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "release-track.release-track-freeze-windows-create-confirmation.app-name-and-site-name": [
    {
      "children": [
        {
          "type": 1,
          "value": "productName"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "siteName"
    }
  ],
  "release-track.release-track-freeze-windows-create-confirmation.apps-included": [
    {
      "type": 0,
      "value": "Apps included"
    }
  ],
  "release-track.release-track-freeze-windows-create-confirmation.blue-atlassian-logo.img.alt": [
    {
      "type": 0,
      "value": "Blue Atlassian logo"
    }
  ],
  "release-track.release-track-freeze-windows-create-confirmation.body.paragraph": [
    {
      "type": 0,
      "value": "Apps that are included in a freeze window won't receive visible changes, deferred changes, and bundled changes."
    }
  ],
  "release-track.release-track-freeze-windows-create-confirmation.body.paragraph-2": [
    {
      "type": 0,
      "value": "You can edit or remove a freeze window up to 48 hours before its scheduled start time. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "More about freeze windows"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "release-track.release-track-freeze-windows-create-confirmation.footer.paragraph": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Administration."
    }
  ],
  "release-track.release-track-freeze-windows-create-confirmation.footer.paragraph-2": [
    {
      "type": 0,
      "value": "You received this email because you're an admin for "
    },
    {
      "type": 1,
      "value": "orgName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "release-track.release-track-freeze-windows-create-confirmation.go-to-freeze-windows-button": [
    {
      "type": 0,
      "value": "Go to Freeze windows"
    }
  ],
  "release-track.release-track-freeze-windows-create-confirmation.header": [
    {
      "type": 0,
      "value": "Your freeze window starts on "
    },
    {
      "type": 1,
      "value": "shortDate"
    }
  ],
  "release-track.release-track-freeze-windows-create-confirmation.message-template.email.subject": [
    {
      "type": 0,
      "value": "Freeze window scheduled for "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " apps "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "release-track.release-track-freeze-windows-create-confirmation.office-building-icon.img.alt": [
    {
      "type": 0,
      "value": "Office building icon"
    }
  ],
  "release-track.release-track-freeze-windows-create-confirmation.product-logo.img.alt": [
    {
      "type": 0,
      "value": "Product logo"
    }
  ],
  "release-track.release-track-freeze-windows-create-confirmation.schedule-details": [
    {
      "type": 0,
      "value": "Schedule details"
    }
  ],
  "release-track.release-track-freeze-windows-create-confirmation.start-end-datetime": [
    {
      "type": 1,
      "value": "startDateTime"
    },
    {
      "type": 0,
      "value": " - "
    },
    {
      "type": 1,
      "value": "endDateTime"
    }
  ],
  "release-track.release-track-freeze-windows-create-confirmation.subheader": [
    {
      "type": 0,
      "value": "An admin from your organization scheduled a freeze window."
    }
  ],
  "release-track.release-track-jira-seasonal-releases.message-template.email.discovery-content": [
    {
      "type": 0,
      "value": "The first set of features will roll out in June, 2026. Changes will be available to test in sandboxes on the preview track from May, 2026. "
    },
    {
      "type": 1,
      "value": "viewAppUpdatesLink"
    },
    {
      "type": 0,
      "value": " to learn more about upcoming dates and changes."
    }
  ],
  "release-track.release-track-jira-seasonal-releases.message-template.email.discovery-title": [
    {
      "type": 0,
      "value": "Jira seasonal releases are coming soon"
    }
  ],
  "release-track.release-track-notifications-custom-notification.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "release-track.release-track-notifications-custom-notification.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "release-track.release-track-notifications-custom-notification.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "release-track.release-track-notifications-custom-notification.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "release-track.release-track-notifications-custom-notification.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "release-track.release-track-notifications-custom-notification.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "release-track.release-track-notifications-custom-notification.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "release-track.release-track-release-common.message-template.email.sent-by": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Administration"
    }
  ],
  "release-track.release-track-release-common.message-template.email.why-sent": [
    {
      "type": 0,
      "value": "You received this email because you're an admin for "
    },
    {
      "type": 1,
      "value": "siteName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "release-track.release-track-subscriptions-subscribed-preview-track-redacted.message-template.email.body": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " sandbox is now on the preview release track. We’ll email you when the product changes roll out to your sandbox."
    }
  ],
  "release-track.release-track-subscriptions-subscribed-preview-track.message-template.email.body": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " sandbox at "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "siteName"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " is now on the preview release track. We’ll email you when the product changes roll out to your sandbox."
    }
  ],
  "release-track.release-track-subscriptions-subscribed-preview-track.message-template.email.subject": [
    {
      "type": 0,
      "value": "Welcome to the preview release track for "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "release-track.release-track-subscriptions-subscribed-preview-track.message-template.email.title": [
    {
      "type": 0,
      "value": "Welcome to the preview release track for your sandbox"
    }
  ],
  "release-track.release-track-subscriptions-subscribed-unredacted.message-template.email.greeting": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "release-track.release-track-subscriptions-subscribed.message-template.email.atlassians": [
    {
      "type": 0,
      "value": "The Atlassians"
    }
  ],
  "release-track.release-track-subscriptions-subscribed.message-template.email.body": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 1,
      "value": "wordAfterProduct"
    },
    {
      "type": 0,
      "value": " at "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "siteName"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " is now on the bundled release track. We’ll email you the list of changes a month before they roll out to your product. Your next release will roll out on "
    },
    {
      "type": 1,
      "value": "releaseFrom"
    },
    {
      "type": 0,
      "value": ". You can also view your upcoming product changes through the "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "release tracks"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " page."
    }
  ],
  "release-track.release-track-subscriptions-subscribed.message-template.email.body.product-word": [
    {
      "type": 0,
      "value": " product"
    }
  ],
  "release-track.release-track-subscriptions-subscribed.message-template.email.body.product-word-appify": [
    {
      "type": 0,
      "value": " app"
    }
  ],
  "release-track.release-track-subscriptions-subscribed.message-template.email.body.redacted": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 1,
      "value": "wordAfterProduct"
    },
    {
      "type": 0,
      "value": " is now on the bundled release track. We’ll email you the list of changes a month before they roll out to your product. Your next release will roll out on "
    },
    {
      "type": 1,
      "value": "releaseFrom"
    },
    {
      "type": 0,
      "value": ". You can also view your upcoming product changes through the "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "release tracks"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " page."
    }
  ],
  "release-track.release-track-subscriptions-subscribed.message-template.email.cheers": [
    {
      "type": 0,
      "value": "Cheers,"
    }
  ],
  "release-track.release-track-subscriptions-subscribed.message-template.email.contact-us": [
    {
      "type": 0,
      "value": "Contact us"
    }
  ],
  "release-track.release-track-subscriptions-subscribed.message-template.email.contact-us-questions": [
    {
      "type": 0,
      "value": " with any questions."
    }
  ],
  "release-track.release-track-subscriptions-subscribed.message-template.email.greeting": [
    {
      "type": 0,
      "value": "Hi, "
    }
  ],
  "release-track.release-track-subscriptions-subscribed.message-template.email.sent-by": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Cloud"
    }
  ],
  "release-track.release-track-subscriptions-subscribed.message-template.email.subject": [
    {
      "type": 0,
      "value": "Welcome to the bundled release track for "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "release-track.release-track-subscriptions-subscribed.message-template.email.title": [
    {
      "type": 0,
      "value": "Welcome to the bundled release track"
    }
  ],
  "release-track.release-track-subscriptions-unsubscribed-redacted.message-template.email.body": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "wordAfterProduct"
    },
    {
      "type": 0,
      "value": " has changed to the continuous release track. Changes will roll out when they are available.\n                            Go to our "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "product changes blog"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to know what changes are rolling out."
    }
  ],
  "release-track.release-track-subscriptions-unsubscribed.message-template.email.body": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "wordAfterProduct"
    },
    {
      "type": 0,
      "value": " at "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "siteName"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " has changed to the continuous release track. Changes will roll out when they are available.\n                            Go to our "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "product changes blog"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to know what changes are rolling out."
    }
  ],
  "release-track.release-track-subscriptions-unsubscribed.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Welcome to the continuous release track for "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "release-track.release-track-subscriptions-unsubscribed.message-template.email.title": [
    {
      "type": 0,
      "value": "Welcome to the continuous release track"
    }
  ]
}